import React, { Fragment, useState, useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import { Polygon, Marker } from 'react-leaflet';
import { useSelector } from 'react-redux';
import { visibleZonesMapSelector, zoneDetailViewSelector } from '../../../features/places/placesSlice';
import { renderToString } from 'react-dom/server';

const iconToolsColor = "Silver";

const OsmZonePolygon = ({ zoneId }) => {
    const map = useMap();
    const zoneData = useSelector(state => state.places.zones[`${zoneId}`]);
    const visibleZonesMap = useSelector(visibleZonesMapSelector);
    const zoneDetailView = useSelector(zoneDetailViewSelector);
    const visible = visibleZonesMap.indexOf(zoneId) !== -1;
    const [showLabel, setshowLabel] = useState(false);

    useEffect(() => {
        if (zoneId === zoneDetailView) {
            setshowLabel(true);
        }
    }, [zoneDetailView, zoneId]);

    useEffect(() => {
        if (visibleZonesMap.length < 6) {
            setshowLabel(true);
        }
    }, [visibleZonesMap])

    const onZoneClick = (e) => {
        //console.log("Zone clickes", zoneData.zone_name, showLabel);
        setshowLabel(!showLabel);
    }

    if (zoneData && visible && map) {
        const labelCenter = () => {
            const center = L.polygon(zonePath()).getBounds().getCenter();
            return [center.lat, center.lng];
        }

        const zonePath = () => {
            let path = [];
            zoneData.zone_coords.forEach(z => {
                path.push([parseFloat(z.lat), parseFloat(z.lng)])
            });
            return path;
        }

        return (
            <Fragment>
                <Marker
                    icon={
                        L.icon({
                            iconUrl: `/assets/history/def15/pentagon_red.png`
                        })
                    }
                    position={labelCenter()}
                    eventHandlers={{ click: (e) => onZoneClick(e) }}
                />
                <Polygon
                    positions={zonePath()}
                    pathOptions={{
                        color: zoneData.zone_color,
                        fillColor: zoneData.zone_color
                    }}
                />
                <Marker
                    icon={
                        L.divIcon({
                            html: renderToString(
                                <span style={{
                                    backgroundColor: iconToolsColor,
                                    position: 'absolute',
                                    left: 10,
                                    top: -10,
                                }}>
                                    <b>
                                        {showLabel ? `${zoneData.zone_name}` : ""}
                                    </b>
                                </span>
                            ),
                            iconAnchor: [0, -5],
                            className: 'dummy'
                        })
                    }
                    position={labelCenter()}
                    eventHandlers={{ click: (e) => onZoneClick(e) }}
                />
            </Fragment>
        );
    } else {
        return null;
    }
}

export default OsmZonePolygon;